import React, { useEffect, useState } from 'react';
import styles from './NewsTab.module.scss';
import { useGetQuery } from '../../../../../../services/apiCall';
import NewsCard from '../../../../../atoms/newsCard/NewsCard';
import endpoints from '../../../../../../api/endpoints';
import Text from '../../../../../atoms/text/Text';
import { useNavigate } from 'react-router-dom';
import Loader from '../../../../../atoms/loader/Loader';
import useIsRtl from '../../../../../../app/helpers/isRtl';

const NewsTab = () => {
  const isRtl = useIsRtl();
  const navigate = useNavigate();
  const apiUrl = endpoints.news.getNews;
  const params = ['4', '1', '?IsActive=true'];
  const { data, error, isLoading } = useGetQuery({
    apiUrl: apiUrl,
    params: params,
  });

  const [delayDone, setDelayDone] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setDelayDone(true), 500);
    return () => clearTimeout(timer);
  }, []);

  if (error) return <p></p>;
  return (
    <div className={styles['cards-container']}>
      {!delayDone || isLoading ? (
        <div className={styles['loader-container']}>
          <Loader />
        </div>
      ) : (
        <>
          <div className={styles.cards} dir={isRtl ? 'rtl' : ''}>
            {data?.items?.map((item) => (
              <NewsCard
                key={item?.newsId}
                id={item?.newsId}
                image={`${item?.url}${item?.image}`}
                date={item?.newsDate}
                title={item?.title_AR}
                description={item?.newsTextAr}
                type="news"
                className={styles.card}
              />
            ))}
          </div>

          <div className={styles['view-container']}>
            <button
              className={styles['view-btn']}
              onClick={() => navigate('/news-and-events/news')}
            >
              <Text
                title="common.view_all"
                variant="text-bold-italic-16"
                maxLines={2}
                className={styles.btnTitle}
              />
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default NewsTab;
